/**
 * PNG-экспорт share-карточек (PULSE-231).
 *
 * html-to-image снимает DOM-узел (включая canvas lightweight-charts)
 * в PNG ×2 — карточка готова для телеграма без скриншотов.
 */
import { toPng } from 'html-to-image'

export async function downloadNodePng(
  node: HTMLElement | null,
  filename: string,
): Promise<void> {
  if (!node) return
  const bg = getComputedStyle(document.documentElement)
    .getPropertyValue('--ink').trim() || '#12151B'
  const dataUrl = await toPng(node, {
    pixelRatio: 2,
    backgroundColor: bg,
    // веб-шрифты уже загружены страницей; embed отключаем — CORS-шум от
    // Google Fonts в консоли и лишний вес не нужны
    skipFonts: false,
  })
  const a = document.createElement('a')
  a.href = dataUrl
  a.download = filename.endsWith('.png') ? filename : `${filename}.png`
  a.click()
}
